import React from 'react';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import ImageAndCtaCard, { ImageAndCtaCardData } from './ImageAndCtaCard';
import ImageAndCtaCardGrid from './ImageAndCtaCardGrid';
import { Heading, ImageAndCtaCardsWrapper, Intro } from './styles';

export type ImageAndCtaCardsProps = {
  heading: string;
  intro?: string;
  cards: ImageAndCtaCardData[];
} & ComponentProps;

const ImageAndCtaCards: React.FC<ImageAndCtaCardsProps> = ({
  heading,
  intro,
  cards,
  ...props
}) => (
  <ImageAndCtaCardsWrapper {...componentProps(props)}>
    <div tabIndex={0}>
      <Heading>{heading}</Heading>
      <Intro>{intro}</Intro>
    </div>
    <ImageAndCtaCardGrid>
      {cards.map((card) => (
        <ImageAndCtaCard
          key={card.heading}
          {...card}
          threeCardVariant={cards.length === 3}
        />
      ))}
    </ImageAndCtaCardGrid>
  </ImageAndCtaCardsWrapper>
);

export { ImageAndCtaCard, ImageAndCtaCardGrid };
export type { ImageAndCtaCardData } from './ImageAndCtaCard';

export default applyComponentTheme(ImageAndCtaCards, 'ImageAndCtaCards');
